// src/stores/user.ts
import { URLs } from '@/constants'
import { generateRandomId } from '@/utils'
import axios from '@/axiosInstance/axiosInstance'
import { defineStore } from 'pinia'

interface UserState {
  isAuthenticated: boolean
  token: string | null
  userType: string | null
  cognitoToken: string | null
  accountId: string | null
  productSetting: {
    Enable: boolean
    couponId: string
  } | null
}

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    isAuthenticated: false,
    token: null,
    userType: null,
    cognitoToken: null,
    accountId: null,
    productSetting: null,
  }),
  actions: {
    // This action sets the "token" property.
    setAuthenticated(isAuthenticated: boolean) {
      this.isAuthenticated = true
    },
    setCognitoToken(cognitoToken: string) {
      this.cognitoToken = cognitoToken
    },
    setUserType(userType: string) {
      this.userType = userType
    },
    setAccountId(accountId: string) {
      this.accountId = accountId
    },
    clearUser() {
      this.userType = null
      this.isAuthenticated = false
      this.cognitoToken = null
      this.accountId = null
      this.token = null
    },
    clearUserType() {
      this.userType = null
    },
    setProductSetting(productSetting: any) {
      this.productSetting = productSetting
    },
    async generateCouponId() {
      if (!this.productSetting) {
        return false
      }
      if (this.productSetting.couponId) {
        return true
      }
      if (!this.productSetting.couponId) {
        try {
          const randomId = generateRandomId()
          const config = {
            url: `${URLs.JAMS_BACKEND_URL}/account/products/${this.accountId}/coupon_builder`,
            method: 'PUT',
            headers: {
              Authorization: `Bearer ${this.cognitoToken}`,
            },
            data: {
              config: {
                couponId: randomId,
              },
            },
          }
          await axios.request(config)
          this.productSetting.couponId = randomId
          return true
        } catch (error) {
          return false
        }
      }
    },
  },
  // You may need to cast this persist config as any to avoid TS errors:
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'user',
        storage: localStorage,
      },
    ],
  } as any,
})
